/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { format, isDate, isValid } from 'date-fns';

export class QueryItem {
  key!: string;
  value!: any;

  constructor(key: string, value: any) {
    this.key = key;
    this.value = value;
  }

  toString(): string {
    //Need to encode key due to unsafe character usage "[", "]" (https://www.rfc-editor.org/rfc/rfc1738)
    return this.key && this.value !== null && this.value !== undefined
      ? `${encodeURIComponent(this.getKey())}=${this.getValue()}`
      : '';
  }

  private getKey(): string {
    if (typeof this.key === 'string' && this.key.startsWith('filter')) {
      return this.key.split('.').join('][');
    }
    return this.key;
  }

  getValue() {
    if (isDate(this.value) && isValid(this.value)) {
      return format(this.value, "yyyy-MM-dd'T'HH:mm:ss");
    }
    return this.value;
  }
}
